<!-- LockSection.vue -->
<template>
  <div v-if="showLockSection" class="lock-section-overlay">
    <div class="lock-section-content">
      <img src="../assets/images/lock.png" alt="" style="width: 50px" />
      <div class="note" style="margin-bottom: 40px">
        <div style="color:red; font-family: Montserrat; font-size: 14px; font-weight: 600; line-height: 17px; letter-spacing: 0em; text-align: center;
">
          To avail this feature, kindly subscribe <span style="text-align: center">to the premium plan</span>

        </div>
        <div class="btn">
          <el-button class="btn-secondary-theme-filled subscribe-btn" v-on:click="goToLink('/pricing')"
            size="medium">Subscribe</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showLockSection: Boolean,
  },

  methods: {
    goToLink(link) {
      if (link) {
        this.$router.push(link);
      }
    },
  },
};

</script>

<style scoped>
.lock-section-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  backdrop-filter: blur(5px);
  /* Adjust the blur amount as needed */
  z-index: 1;
  /* Ensure the lock section is on top of the underlying content */
  display: flex;
  align-items: center;
  justify-content: center;
}

.lock-section-content {
  text-align: center;
}

.btn {
  margin-top: 30px;
}

.btn .subscribe-btn {
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 60px;
  padding-right: 60px
}

@media screen and (max-width: 991px) {
  .btn {
    display: block;
  }
}

@media screen and (min-width: 992px) {
  .btn {
    display: none;
    /* Hide the container */
  }
}
</style>
